import type { SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement>;

const shared = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.65,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
};

/** A focused work surface with three incoming signals converging on one action. */
export function WorkbenchMark({ className, ...props }: IconProps) {
  return (
    <svg {...shared} className={className} {...props}>
      <path d="M4 6.25h5.25M14.75 6.25H20M6.75 12h10.5M4 17.75h5.25M14.75 17.75H20" opacity=".45" />
      <circle cx="12" cy="6.25" r="2.15" />
      <rect
        x="9.15"
        y="9.15"
        width="5.7"
        height="5.7"
        rx="1.65"
        fill="currentColor"
        stroke="none"
      />
      <circle cx="12" cy="17.75" r="2.15" />
      <path d="M12 8.4v.75M12 14.85v.75" />
    </svg>
  );
}

/** A process path moving through prerequisite, work, and delivery stages. */
export function RunwayMark({ className, ...props }: IconProps) {
  return (
    <svg {...shared} className={className} {...props}>
      <path d="M4.25 16.75c2.6 0 2.6-9.5 5.25-9.5s2.6 9.5 5.25 9.5c2.35 0 2.55-7.15 4.6-9.05" />
      <path d="m16.9 7.65 2.75-.25-.25 2.75" />
      <rect x="2.6" y="15.1" width="3.3" height="3.3" rx=".9" fill="currentColor" stroke="none" />
      <circle cx="9.5" cy="7.25" r="1.7" />
      <path d="m13.15 16.75 1.6-1.6 1.6 1.6-1.6 1.6z" fill="currentColor" stroke="none" />
    </svg>
  );
}

/** A client portfolio: one lead record with two supporting records behind it. */
export function PortfolioMark({ className, ...props }: IconProps) {
  return (
    <svg {...shared} className={className} {...props}>
      <path d="M7 5.25h10a2 2 0 0 1 2 2v9.5a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-9.5a2 2 0 0 1 2-2Z" />
      <path d="M8.5 5.25v-1A1.75 1.75 0 0 1 10.25 2.5h7A1.75 1.75 0 0 1 19 4.25v10" opacity=".45" />
      <circle cx="9.25" cy="10" r="1.65" fill="currentColor" stroke="none" />
      <path d="M12.5 9.25h3.25M8 14.25h8" />
    </svg>
  );
}

/** Reusable building blocks moving from catalog cells into a composed object. */
export function LibraryMark({ className, ...props }: IconProps) {
  return (
    <svg {...shared} className={className} {...props}>
      <rect x="3" y="3" width="5.25" height="5.25" rx="1.25" />
      <rect x="3" y="10.5" width="5.25" height="5.25" rx="1.25" />
      <rect x="10.5" y="3" width="5.25" height="5.25" rx="1.25" />
      <path d="M11.25 13.75h3.5M13 12v3.5" opacity=".55" />
      <path d="M11 18.75h7.25A2.75 2.75 0 0 0 21 16V8.75" />
      <path d="m18.5 10.5 2.5-2.5-2.5-2.5" />
      <rect
        x="10.5"
        y="10.5"
        width="5.25"
        height="5.25"
        rx="1.25"
        fill="currentColor"
        stroke="none"
      />
    </svg>
  );
}
